// extracted by mini-css-extract-plugin
module.exports = {"container":"innate_container_yvaPi"};